import React from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import "../styles.css";

// Ссылка-иконка «создать» (плюс), обычно в ячейке create шапки списка.
export default function ButtonLinkAdd({ href, title = 'Создать', className = '', ...other }) {
    if (!href) return null;
    return <Link {...other} to={href} title={title} className={`button-link ${className}`}>
        <AddIcon fontSize="small"/>
    </Link>;
}
